import { useRef } from "react";
import { hotAnime } from "@/mocks/anime";

export default function Featured() {
  const trackRef = useRef<HTMLDivElement>(null);

  const scrollBy = (dir: number) => {
    trackRef.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  return (
    <section id="hot" className="section-pad">
      <div className="container-site">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-accent-600">Hot Pick</span>
            <h2 className="mt-1 font-heading text-3xl md:text-4xl">本周热门 · 大家正在追</h2>
            <p className="mt-2 max-w-lg text-sm text-foreground-600">
              高分好番抢先看，均支持高清画质与全集连播，点开就能一口气刷到底。
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => scrollBy(-1)}
              className="grid h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-100 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              aria-label="上一组"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <button
              type="button"
              onClick={() => scrollBy(1)}
              className="grid h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-100 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              aria-label="下一组"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>

        <div
          ref={trackRef}
          className="mt-8 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2"
          style={{ scrollbarWidth: "thin" }}
        >
          {hotAnime.map((anime) => (
            <a
              href="#binge"
              key={anime.id}
              className="group relative w-[240px] shrink-0 snap-start overflow-hidden rounded-2xl bg-background-100 card-shadow transition-transform duration-300 hover:-translate-y-1.5"
            >
              <div className="relative h-[320px] overflow-hidden">
                <img
                  src={anime.image}
                  alt={`${anime.title} 卡通动漫综合高清全集`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
                {anime.badge && (
                  <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-2.5 py-1 text-[11px] font-medium text-foreground-950">
                    {anime.badge}
                  </span>
                )}
                <span className="absolute right-3 top-3 rounded-full bg-foreground-950/60 px-2 py-1 text-[11px] text-secondary-300 backdrop-blur-sm">
                  <i className="ri-star-fill mr-0.5 text-secondary-400" />
                  {anime.score}
                </span>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="font-heading text-lg text-background-50">{anime.title}</h3>
                  <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-background-100/80">
                    <span className="rounded-full bg-background-50/15 px-2 py-0.5">{anime.category}</span>
                    <span>{anime.episodes}</span>
                    <span className="rounded-full bg-primary-500/80 px-2 py-0.5 text-background-50">{anime.status}</span>
                  </div>
                </div>
                <div className="absolute inset-0 grid place-items-center bg-foreground-950/0 opacity-0 transition-opacity duration-300 group-hover:bg-foreground-950/40 group-hover:opacity-100">
                  <span className="flex items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50">
                    <i className="ri-play-fill" />
                    立即开刷
                  </span>
                </div>
              </div>
              <div className="px-3 py-3">
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{anime.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}